import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/contexts/auth-context';

/**
 * Guard pour les routes protégées.
 * Redirige vers / (page Welcome avec login) si l'utilisateur n'est pas connecté.
 */
export function RequireAuth({ children }) {
    const { isAuthenticated } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        // Sauvegarder l'URL d'origine pour rediriger après connexion (optionnel)
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}
